<div class="chart-container" [nbSpinner]="loading">
  <div class="header">
    <div class="title">{{ leftLabel }}</div>
    <div class="title">{{ rightLabel }}</div>
  </div>

  <div class="rows">
    <div class="row" *ngFor="let item of data">
      <div class="label-value-container">
        <span class="label">
          <app-agent-identity-label
            *ngIf="isAgentItem(item); else plainLabel"
            [visualName]="item.bot_visual_name || item.label"
            [internalName]="item.bot_name"
            [fallback]="item.label"
            [compact]="true"
          ></app-agent-identity-label>
          <ng-template #plainLabel>{{ item.label }}</ng-template>
        </span>
        <span class="value">{{ formatValue(item.value) }}</span>
      </div>
      <div class="bar-container">
        <div class="bar" [style.width.%]="getBarWidth(item.value)"></div>
      </div>
    </div>
  </div>
</div>
